import React from "react";
import util from 'lodash/util';

import { withRouter, Redirect } from "react-router";
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';

import AuthUserContext from '../Session/AuthUserContext';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import CaazamDevice from '../CaazamModel/CaazamDevice';
import { iTunes, GooglePlay } from '../Constants/AppStores';
import { logo } from '../Constants/assets';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    paddingTop: theme.spacing.unit * 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    overflowY: 'scroll',    
  },

  container: {    
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    maxWidth: 350,
    [theme.breakpoints.up('sm')] : {
      marginTop: theme.spacing.unit * 4,
      border: '1px solid rgba(255,149,0,0.5)',
    },
    justifyContent: 'center',
    alignItems: 'center',
  },

  logo: {
    width: 200,
    height: 200,
    display: 'block',
    //marginBottom: theme.spacing.unit * 2,
  },

  tagline: {
    fontFamily: 'Comfortaa',
    fontWeight: 100,
    textAlign: 'center',
    maxWidth: '75%',
    marginBottom: theme.spacing.unit * 4,
  },

  loginButton : {
    width: '75%',
    marginBottom: theme.spacing.unit * 6,
  },

  downloadText : {
    color: theme.palette.primary.dark,
    fontWeight: 500,
    textAlign: 'center',
    margin: 'auto',
  },

  appStores: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'block',
  },
});

class Landing extends React.Component {

  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => authUser
          ? <Redirect to={routes.HOME}/>
          : <LandingContent classes={this.props.classes}/>
        }
      </AuthUserContext.Consumer>
    )
  }
}

class LandingContent extends React.Component {

  render() {
    const {classes} = this.props;
    var showiTunes = iTunes;
    var showGoogle = GooglePlay;
    var store ='Download Caazam! for free:';
    if (CaazamDevice.isApple()) {
      showGoogle = null;
      store = 'Downlaod Caazam! for free on the App Store:';
    } else if (CaazamDevice.isAndroid()) {
      showiTunes = null;
      store = 'Downlaod Caazam! for free on Google Play:';
    }

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <img className={classes.logo} src={logo} alt='Caazam! logo' />
          <Typography className={classes.tagline} variant="title" color={'primary'} gutterBottom>
            Photos of you, delivered to you. In seconds...
        </Typography>
          <Button variant='raised' color={'primary'} className={classes.loginButton} component={Link} to={routes.SIGN_IN} >LOGIN</Button>

          <Typography className={classes.downloadText}>
            {'Capture photos and more...'}
          </Typography>
          <Typography className={classes.downloadText} gutterBottom>
            {store}
          </Typography>
          <div className={classes.appStores}>
            {showiTunes && showiTunes()}
            {showGoogle && showGoogle()}
          </div>
        </div>
      </div>
    );
  }
}


var enhance = util.flowRight(
  withRouter,
  withStyles(styles),
);

export default enhance(Landing);



// WEBPACK FOOTER //
// ./src/CaazamApp/Landing.js